export default function PageHeader({ title, subtitle, action, testid, greeting }) {
  return (
    <div data-testid={testid} className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 md:mb-7">
      <div className="min-w-0">
        {greeting && <div className="text-[13px] text-[#8E8E93] mb-1">{greeting}</div>}
        <h1 className="font-display font-semibold text-[30px] sm:text-[36px] tracking-[-0.04em] text-[#332B26] leading-[1.02]">{title}</h1>
        {subtitle && <p className="mt-2 text-[13px] sm:text-[13.5px] text-[#81766D] max-w-2xl">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
